import { render } from "./RepPatSummary.vue?vue&type=template&id=20b5fd24"
import script from "./RepPatSummary.vue?vue&type=script&lang=js"
export * from "./RepPatSummary.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__